import Image from 'next/image'
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Absolute } from '../../../parts/bases/Absolute'
import { Center } from '../../../parts/bases/Center'
import { Fixed } from '../../../parts/bases/Fixed'
import { HStack } from '../../../parts/bases/HStack'
import { Space } from '../../../parts/bases/Space'
import { Text } from '../../../parts/bases/Text'
import { VStack } from '../../../parts/bases/VStack'
import { PinkNeonButton } from '../../../parts/buttons/PinkNeonButton'
import loginDialogLeftTop from '../../../../../public/images/loginDialogLeftTop.png'
import loginDialogTop from '../../../../../public/images/loginDialogTop.png'
import loginDialogRightTop from '../../../../../public/images/loginDialogRightTop.png'
import loginDialogVerticalBorder from '../../../../../public/images/loginDialogVerticalBorder.png'
import loginDialogLeftBottom from '../../../../../public/images/loginDialogLeftBottom.png'
import loginDialogBottom from '../../../../../public/images/loginDialogBottom.png'
import loginDialogRightBottom from '../../../../../public/images/loginDialogRightBottom.png'
import metamaskLogo from '../../../../../public/images/metamaskLogo.png'

export type Props = {
  onClickConnectToMetamsk: () => void
  visibleLoading: boolean
  state:
    | { type: 'INVISIBLE' }
    | { type: 'REQUIRED_USER_ACCOUNT_CONNECTED' }
    | { type: 'WRONG_CHAIN_ID' }
    | { type: 'WRONG_WALLET_ADDRESS'; walletAddress: string }
}

export const Layout = ({
  children,
  onClickConnectToMetamsk,
  visibleLoading,
  state,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation()
  return (
    <>
      {state.type === 'INVISIBLE' ? (
        <>{children}</>
      ) : (
        <>
          {state.type === 'REQUIRED_USER_ACCOUNT_CONNECTED' ? (
            <>
              <PinkNeonButton type="Sub" size="S" onClick={onClickConnectToMetamsk} loading={visibleLoading}>
                <HStack className="items-center justify-center ">
                  <Center className="relative mr-2 aspect-[99/90] w-4">
                    <Image src={metamaskLogo} layout="fill" alt="" />
                  </Center>
                  <Text className="text-sm text-white">
                    {t('MetamaskConnectionChecker.AlertConnectButton')}
                  </Text>
                </HStack>
              </PinkNeonButton>
            </>
          ) : null}
          {state.type === 'WRONG_CHAIN_ID' || state.type === 'WRONG_WALLET_ADDRESS' ? (
            <Fixed className="top-0 left-0 z-50 h-screen w-screen bg-black bg-opacity-80">
              <Center className="h-full w-full">
                <VStack className="w-1/2 max-w-[700px] items-center p-[18px]">
                  <Absolute className="top-0 left-0 bottom-0 w-full p-[9px]">
                    <VStack className="w-full">
                      <HStack className="w-full">
                        <Center className="relative aspect-[168/295] w-12">
                          <Image priority src={loginDialogLeftTop} layout="fill" alt="Logo" />
                        </Center>
                        <Center className="relative mr-2 w-2">
                          <Image priority src={loginDialogTop} layout="fill" alt="Logo" />
                        </Center>
                        <Center className="relative flex-1">
                          <Image priority src={loginDialogTop} layout="fill" alt="Logo" />
                        </Center>
                        <Center className="relative aspect-[168/295] w-12">
                          <Image priority src={loginDialogRightTop} layout="fill" alt="Logo" />
                        </Center>
                      </HStack>
                      <HStack className="w-full flex-1">
                        <Center className="relative aspect-[54/12] w-[15.5px]">
                          <Image priority src={loginDialogVerticalBorder} layout="fill" alt="Logo" />
                        </Center>
                        <Space />
                        <Center className="relative aspect-[54/12] w-[15.5px]">
                          <Image priority src={loginDialogVerticalBorder} layout="fill" alt="Logo" />
                        </Center>
                      </HStack>
                      <HStack className="w-full">
                        <Center className="relative aspect-[168/306] w-12">
                          <Image priority src={loginDialogLeftBottom} layout="fill" alt="Logo" />
                        </Center>
                        <Center className="relative flex-1">
                          <Image priority src={loginDialogBottom} layout="fill" alt="Logo" />
                        </Center>
                        <Center className="relative aspect-[315/306] w-[100px]">
                          <Image priority src={loginDialogRightBottom} layout="fill" alt="Logo" />
                        </Center>
                      </HStack>
                    </VStack>
                  </Absolute>
                  <VStack className="min-h-[200px] w-full items-center justify-center rounded-[22px] bg-black p-6">
                    {state.type === 'WRONG_WALLET_ADDRESS' ? (
                      <Text className="text-center text-white">
                        {t('MetamaskConnectionChecker.AlertDescriptionRequiredMetamaskPermission', {
                          walletAddress: state.walletAddress,
                        })}
                      </Text>
                    ) : null}
                    {state.type === 'WRONG_CHAIN_ID' ? (
                      <VStack className="items-center">
                        <Center className="relative mt-7 mb-9 aspect-[99/90] w-20">
                          <Image src={metamaskLogo} layout="fill" alt="" />
                        </Center>
                        <Text className="text-center text-white">
                          {t('MetamaskConnectionChecker.AlertDescriptionWrongChainId', {
                            networkName: t(`MetamaskConnectionChecker.${process.env.NEXT_PUBLIC_CHAIN_ID}`),
                          })}
                        </Text>
                      </VStack>
                    ) : null}
                  </VStack>
                </VStack>
              </Center>
            </Fixed>
          ) : null}
        </>
      )}
    </>
  )
}
